<!--
 * @Author: your name
 * @Date: 2021-11-26 16:53:51
 * @LastEditTime: 2021-11-29 11:16:07
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\components\make-ticket-company-select\index.vue
-->
<template>
  <a-select
    :value="value"
    :show-search="showSearch"
    :allow-clear="allowClear"
    :mode="mode || undefined"
    :placeholder="placeholder"
    :disabled="disabled"
    option-filter-prop="title"
    @change="onChange"
  >
    <a-select-option
      v-for="item in data"
      :key="item.id"
      :value="item.id"
      :title="item.companyName"
      :disabled="disableArray.includes(item.id)"
    >
      {{ item.companyName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref } from "vue";
import { CompanyService } from "@/views/cooperation/company/company.service";

type IValue = string[] | string | undefined;
type ISelectMode = undefined | "" | "multiple" | "tags" | "combobox";

/**
 * 全局组件: 字段选择器
 *
 * 使用方式:
 * <dict-select v-model="formRef.dictCode" code="sex"></dict-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "MakeTicketCompanySelect",
  props: {
    value: {
      type: [Array, String] as PropType<IValue>,
      default: undefined,
    },
    mode: {
      type: String as PropType<ISelectMode>,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableArray: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const onChange = (code) => {
      emit("update:value", code);
      emit("change", code);
    };
    const { data, run } = CompanyService.usePageApi();

    onMounted(async () => {
      await run({ page: 1, size: 10000 });
    });
    return {
      onChange,
      data,
    };
  },
});
</script>
